var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.5 0.207153L2.5 8.87506L10.5 17.543H8L0 8.87506L8 0.207153H10.5Z","fill":"black"}));
}

ChevronLeftInline.defaultProps = {"width":"11","height":"18","viewBox":"0 0 11 18","fill":"none"};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
